import { ArtistArt } from "@components/artist_art/artist_art";
import { ArtistInfo } from "@components/artist_page/artist_info/artist_info";
import { BioBox } from "@components/bio_box/bio_box";
import { useQuery } from "@hooks/use_query";
import { api } from "@services/api";
import React, { FC, useEffect, useMemo } from "react";

interface ArtistPageProps {
  artistIdOrSlug: string;
}

const ArtistPage: FC<ArtistPageProps> = ({ artistIdOrSlug }) => {
  const apiCall = useMemo(() => {
    return (token: string) => () => api.artist.details(artistIdOrSlug, token);
  }, [artistIdOrSlug]);
  const { data, fetchData: fetchArtistData, loading } = useQuery(apiCall);

  useEffect(() => {
    fetchArtistData();
  }, [fetchArtistData]);

  if (!artistIdOrSlug) {
    return null;
  }

  if (loading) {
    return null;
  }

  return (
    data && (
      <div className="artist-page">
        <section className="artist-page--info">
          <ArtistInfo artist={data} />
          {data.bio && data.bio.length ? (
            <div className="artist-page--bio--desktop">
              <BioBox bioText={data.bio} />
            </div>
          ) : null}
        </section>
        <section className="artist-page--artwork">
          <ArtistArt artPieces={data.artPieces} />
        </section>
        {data.bio && data.bio.length ? (
          <section className="artist-page--bio--mobile">
            <BioBox bioText={data.bio} />
          </section>
        ) : null}
      </div>
    )
  );
};

export { ArtistPage, ArtistPageProps };
